import '../style/notfound.css';

const NotFound = () => {
  return <div className="warning">Тут ничего нет</div>;
};

export default NotFound;
